import { User } from '../types';
import { getFacilityId } from './apiHelpers';

/**
 * Get facility ID from user object (camelCase first, snake_case fallback).
 */
export const getUserFacilityId = (user: User | null | undefined): string | undefined => {
  return getFacilityId(user);
};

/**
 * Get isActive status from user object (camelCase first, snake_case fallback).
 */
export const getUserIsActive = (user: User | null | undefined): boolean => {
  if (!user) return false;
  return user.isActive ?? user.is_active ?? false;
};

/**
 * Get emailVerified status from user object (camelCase first, snake_case fallback).
 */
export const getUserEmailVerified = (user: User | null | undefined): boolean => {
  if (!user) return false;
  return user.emailVerified ?? user.email_verified ?? false;
};


